new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
    mounted() {
        waitForElementToExist('#faixa-cupom').then(element => {
            const faixCupom = document.querySelector('.faixa-cupom');

            if (faixCupom) {
                const formButton = document.querySelector('.faixa-cupom-form button');
                const spanElement = document.getElementById("valorParaCopiar");

                if (spanElement) {
                    let newValue = spanElement.textContent.replace(/^\/\//, '');

                    if (formButton) {
                        formButton.addEventListener("click", (e) => {
                            e.preventDefault();

                            navigator.clipboard.writeText(newValue).then(() => {
                                alert("Valor copiado: " + newValue);
                            }).catch(err => {
                                console.error('Erro ao copiar: ', err);
                                alert("Erro ao copiar o valor.");
                            });
                        });
                    }
                }
            }
        });
    },
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        swipeToSlide: true, 
        touchThreshold: 100,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        infinite: false,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 300,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    waitForElementToExist('.banner-product').then(element => {
        $('#product-banner').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                    }
                }
            ]
        });

        $('#product-banner').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list');
        if (firstCarrousel) {
            $('#product_list').slick({
                arrows: true,
                swipeToSlide: true, 
                touchThreshold: 100,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToScroll: 3,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1275,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.banner-traditional').then(element => { 
        $('.group-banners').slick({
            arrows: false,
            swipeToSlide: true, 
            touchThreshold: 100,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 100,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });
    });

    waitForElementToExist('.instagram-feed').then(element => {
        $('.instagram-feed__list').slick({
            arrows: false,
            swipeToSlide: true,
            touchThreshold: 100,
            dots: false,
            autoplay: true,
            autoplaySpeed: 3000,
            pauseOnHover: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 400,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });
    });

    waitForElementToExist('.banner-perso').then(element => {
        $('#carrousel-banner-perso').slick({
            arrows: false,
            swipeToSlide: true, 
            touchThreshold: 100,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 100,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list2');
        if (firstCarrousel) {
            $('#product_list2').slick({
                arrows: true,
                swipeToSlide: true, 
                touchThreshold: 100,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToScroll: 3,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1275,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list2').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.third-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list3');
        if (firstCarrousel) {
            $('#product_list3').slick({
                arrows: true,
                swipeToSlide: true, 
                touchThreshold: 100,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToScroll: 3,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1275,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list3').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.product-ratings').then(element => {
        const productRatings = element.querySelector('.product-ratings-list');
        if(productRatings) {
            $('.product-ratings-list').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: false,
                dots: true,
                adaptiveHeight: true,
                autoplay: true,
                autoplaySpeed: 2000,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 3,
                            slidesToShow: 3,
                            dots: false,
                            adaptiveHeight: true,
                        }
                    },
                ]
            });

            $('.product-ratings-list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

});